module.exports = __webpack_public_path__ + "img/53.03b64597.png";